export class Titles {

    public titleApproveDocumentsAdvance = '¿Deseas aprobar la cuenta bancaria de anticipos para pago?';
    public titleApproveDocumentsBalance = '¿Deseas aprobar la cuenta bancaria de saldo para pago?';
    public titleNoApproveDocumentsAdvance = '¿Deseas rechazar la cuenta bancaria de anticipos para pago?';
    public titleNoApproveDocumentsBalance = '¿Deseas rechazar la cuenta bancaria de saldo para pago?';
    public titleModalExportXLSX = '¿Deseas exportar el Reporte?';
    public titleModalExportNovelties = '¿Deseas exportar en un archivo XLSX las Novedades?';
    public titleModalConfirm = 'Confirmar';
    public titleModalNo = 'No';
    public titleModalCancel = 'Cancelar';
    public errorExportFile = 'Ocurrió un error generando el archivo';
    public errorGetReports = 'Ocurrió un error consultando el reporte';
    public titlesModalApproveCargo = '¿Desea aprobar el servicio por un total de ';
    public titlesModalApproveCargos = '¿Desea aprobar los servicios por un total de ';
    public titlesModalFulFillCargo = '¿Desea cumplir el servicio por un total de ';
    public titlesModalFulFillCargos = '¿Desea cumplir los servicios por un total de ';
    public titlenModalReturnApproveCargo = '¿Desea retornar al estado "Pendiente por Aprobar" el servicio ';
    public titlesModalCashedCargo = '¿Desea confirmar el cobro de los servicios seleccionados?';
    public titleModalExtraAdvance = 'Generar y descargar archivo de pago sobre anticipos';
    public titlesModalFileForPaymentsCargo = '¿Desea descargar el archivo para pagar los servicios seleccionados?';
    public titlesModalFileForPaymentsTravelExpenses = '¿Desea descargar el archivo para pagar los viáticos seleccionados?';
    public titleRefuseCargo = '¿Por que desea rechazar el servicio?';
    public titleRefuseCargos = '¿Por que desea rechazar los servicios?';
    public titleBillCargo = 'Para confirmar el cobro, por favor ingrese el numero de factura';
    public titleIncomeCargo = 'Para confirmar el ingreso, por favor escriba el numero de Comprobante';
    public titleConfirmDriver = 'Confirmación De Conductor Asignado';
    public titleBottonRefuse = 'Rechazar';
    public titleConfirmeSave = '¡ Actualizacion de Informacion Bancaria !';
    public titleFintech = "Enviar servicios a LoggiCash"
}
